// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"a40d5a70","517":"aafd747f"}[chunkId] + ".chunk.js";
};